import { LabelConfig } from 'modules/workflows';

/**
 * Gets a flat string of label names from the label configs
 */
export const getLabelNames = (labels: LabelConfig[] = []): string[] =>
  labels?.map(({ name }) => name as string);

/**
 * Gets the associated label configs from the label names
 */
export const getLabelConfigsFromNames = (
  labelNames: string[] = [],
  labelConfigs: LabelConfig[] = [],
): LabelConfig[] =>
  labelNames.reduce((acc: LabelConfig[], labelName: string) => {
    const labelConfig = labelConfigs.find((l) => l.name === labelName);
    return labelConfig ? [...acc, { ...labelConfig, name: labelName } as LabelConfig] : acc;
  }, [] as LabelConfig[]);

/**
 * Adds project id to labels -- needed for saving to the backend
 */
export const addProjectIdToLabels = (labels: LabelConfig[] = [], projectId: number) =>
  labels.map((label) => ({ ...label, projectId }));
